import React, { lazy } from "react";

import { Navigate } from "react-router-dom";
import RemoteFace from "@/pages/RemoteFace";
import FaceResult from "@/pages/FaceResult";

const Layout = lazy(() => import("@/pages/Layout"));
const My = lazy(() => import("@/pages/My"));
const Home = lazy(() => import("@/pages/Home"));

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  auth?: boolean;
  children?: RouteConfig[];
  redirect?:string
}


const route:RouteConfig[] = [
  {
    path: "/",
    element: <Navigate to="/home"></Navigate>,
  },
  {
    path: "/home",
    element: <Layout></Layout>,
    children: [
      {
        path: "/home",
        element: <Navigate to="/home/index"></Navigate>,
      },
      {
        path: "/home/index",
        element: <Home></Home>,
      },
      {
        path: "/home/my",
        element: <My></My>,
      },
    ],
  },
  {
    path: "/home",
    element: <Layout></Layout>,
    children: [
      {
        path: "/home",
        element: <Navigate to="/home/index"></Navigate>,
      },
      {
        path: "/home/index",
        element: <Home></Home>,
      },
      {
        path: "/home/my",
        element: <My></My>,
      },
    ],
  },
  {
    path: '/remoteFace',
    element: <RemoteFace></RemoteFace>
  },
  {
    path: '/faceResult',
    element: <FaceResult></FaceResult>
  },
  {
    path: "*",
    element: <Navigate to="/home"></Navigate>,
  },
];

export default route;
